<div data-testid="commission-by-travel-type-container">
  <app-generic-chart 
    [data]="data" 
    [presentationType]="presentationType"
    [chartConfiguration]="chartConfiguration">
  </app-generic-chart>
</div>